import { enqueueSnackbar, } from 'notistack'
import axios, { AxiosResponse, } from 'axios'
import { put, call, takeLatest, takeLeading, } from 'redux-saga/effects'

import {
  GET_AGENTS,
  SEARCH_AGENTS,
  LOAD_MORE_AGENTS,
  LOAD_MORE_SEARCH_AGENTS,
  setAgents,
} from '@reducers/userManagement'

import { authorizedAxios, } from '@utils'

import { urls, } from '@globals'

import { Agent, TypePagination, TypePaginationResult, } from '@types'

import { withAppState, } from './utils'

const normalizePaginatedAgents = (data: any): TypePaginationResult<Agent> => {
  if(Array.isArray(data)) {
    return {
      pagination: {
        count: data.length,
        next: '',
        previous: '',
      },
      results: data,
    }
  }

  if(data.pagination && Array.isArray(data.results)) {
    return data
  }

  return {
    pagination: {
      count: data.count || 0,
      next: data.next || '',
      previous: data.previous || '',
    },
    results: data.results || [],
  }
}

function* getAgents({ pagination, includeEndOfWork, append, }: {
  type: string
  pagination: TypePagination
  includeEndOfWork?: boolean
  append?: boolean
}) {
  const response: AxiosResponse<any> = yield call(authorizedAxios, urls.users.AGENTS, {
    method: 'GET',
    params: {
      ... pagination,
      include_end_of_work: includeEndOfWork,
    },
  })

  yield put(setAgents(normalizePaginatedAgents(response.data), append))
}

function* searchAgents({ pagination, searchValue, append, }: {
  type: string
  pagination: TypePagination
  searchValue: string
  append?: boolean
}) {
  const response: AxiosResponse<any> = yield call(authorizedAxios, urls.users.AGENTS, {
    method: 'GET',
    params: {
      ... pagination,
      search_value: searchValue,
    },
  })

  yield put(setAgents(normalizePaginatedAgents(response.data), append))
}

const userManagementSagas = [
  takeLatest(GET_AGENTS, withAppState('GET_AGENTS', getAgents)),
  takeLatest(SEARCH_AGENTS, withAppState('SEARCH_AGENTS', searchAgents)),
  takeLeading(LOAD_MORE_AGENTS, withAppState('LOAD_MORE_AGENTS', getAgents)),
  takeLeading(LOAD_MORE_SEARCH_AGENTS, withAppState('LOAD_MORE_SEARCH_AGENTS', searchAgents)),
]

export default userManagementSagas
